// Disable some point styles for line chart
// as they are not rendered
export const disabledPointStyles = ['cross', 'crossRot', 'dash', 'line', 'star'];